import { useEffect, useState } from "react"
import type { DataTypePaging, SuccessFetch } from "types"
import { defaultListWithPagination, useApi } from "utils"
import { FilterDataType, RefundItemListResponse } from "../types"

export const useGetListRefundItem = (props: FilterDataType) => {
  const api = useApi()
  const [data, setData] = useState<DataTypePaging<RefundItemListResponse>>(defaultListWithPagination)
  const [isLoading, setLoading] = useState(true)

  const params: { [key: string]: number | string | undefined } = {}
  if (props?.page) params.page = props?.page;
  if (props?.limit) params.limit = props?.limit;
  if (props?.search) params.search = props?.search;
  if (props?.date_from) params.start_date = props?.date_from;
  if (props?.date_end) params.end_date = props?.date_end;
  if (props?.location_id) params.location_id = props?.location_id;
  if (props?.return_item_id) params.return_id = props?.return_item_id;
  if (props?.approval) params.approve_status = props?.approval;
  if (props?.search) params.search = props?.search;

  const fetchingDataApi = () => api.get("/received/list_refund_return_by_register", {params})

  const fetchingData = () => {
    setLoading(true);

    fetchingDataApi()
    .then((res: SuccessFetch<DataTypePaging<RefundItemListResponse>>) => setData(res.data))
    .catch(() => setData(defaultListWithPagination))
    .finally(() => setLoading(false));
  }

  const refetch = () => fetchingData();

  useEffect(() => {
    if (!props.date_from || !props.date_end) return;
    fetchingData();

    return () => {
      //
    }
    // eslint-disable-next-line
  }, [props.page, props.limit, props.search, props.date_from, props.date_end, props.location_id, props.return_item_id, props.approval])


  return { data, isLoading, refetch }
}